import React, { useEffect } from 'react'
import { MainScreen } from './components/main-screen'
import { PartnersScreen } from './components/partners-screen'
import { BusinessAreas } from './components/business-areas'
import { QuestionsScreen } from '~common/questions-screen'
import { BusinessProcesses } from './components/business-processes'
import { PriceCalculateScreen } from '~common/price-calculate-screen'
import { SellMoreScreen } from '~common/sell-more-screen'
import { FreePeriodScreen } from './components/free-period-screen'
import { SetupStepsScreen } from './components/setup-steps-screen'
import { MobileAppScreen } from './components/mobile-app-screen'
import { ServicesScreenGroup } from './components/services-screen-group'
import { ReviewsScreen } from '../../common/reviews-screen'
import { AmplitudeCounter } from "~/amplitude-counter";

const IndexPageOld: React.FC = () => {
  useEffect(() => AmplitudeCounter('view_site'), [])

  return (
    <>
      <MainScreen />
      <PartnersScreen />
      <BusinessAreas />
      <ServicesScreenGroup />
      <SetupStepsScreen />
      <QuestionsScreen />
      <BusinessProcesses />
      <FreePeriodScreen />
      <MobileAppScreen />
      <ReviewsScreen />
      <PriceCalculateScreen />
      <SellMoreScreen />
    </>
  )
}

export { IndexPageOld }